import { OrderByArg } from 'shared/domains/apollo/generated/types';
export function validateOrderBy(orderBy) {
    const valid = Boolean(orderBy && Object.keys(orderBy).length);
    const defaultOrderBy = { updatedAt: OrderByArg.Desc };
    if (!valid) {
        return defaultOrderBy;
    }
    return orderBy;
}
